module.exports = __webpack_public_path__ + "img/activities-simulation.a0c47f36.png";